import React from "react";
import Button from "../../Button";

export default function Project(props) {
  const className = [props.className];
  const handleAllFunc = () => {
    props.openProjectModal();
    props.getProjectId(props.id);
  };
  return (
    <div
      className={["flex md:p-6 p-1", className].join(" ")}
      style={{ overflow: "hidden" }}
    >
      <div className="relative w-full project-card h-40 flex justify-center items-center bg-black">
        <div>{props.children}</div>
        <div className="absolute bg-gray-900 text-white w-full h-full opacity-0 hover:opacity-100 flex flex-col justify-center items-center transition duration-500">
          <div className="w-9/12 select-none">
            <p className="mb-3">{props.desc}</p>
            <Button
              isSecondary
              isDense
              className="py-1"
              onClick={handleAllFunc}
            >
              Details
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
